import { Injectable, signal } from '@angular/core';
import { AbstractCategoryFormService } from '../../../common/category-details/abstract-category-form-service';
import {
  createOfferCategoryAsync,
  findOfferCategoryAsync,
  updateOfferCategoryAsync,
} from '../../../../backend/main';
import type { CategoryDetailsFormValues } from '../../../common/category-details/category-details-form';
import { CategoryDetailsForm } from '../../../common/category-details/category-details-form';

@Injectable()
export class OfferCategoryFormService extends AbstractCategoryFormService<CategoryDetailsFormValues> {
  readonly i18nPrefix = signal('PAGES.OFFER.CATEGORY');

  readonly findCategoryAsync = findOfferCategoryAsync;
  readonly createCategoryAsync = createOfferCategoryAsync;
  readonly updateCategoryAsync = updateOfferCategoryAsync;

  createForm(): CategoryDetailsForm {
    return new CategoryDetailsForm();
  }
}
